import messages from './messages';

export type ErrorCode = Record<string, { id: string; defaultMessage: string }>;

export const payrollErrorCodes: ErrorCode = {
  PAYROLL_EXPORT_FILENAME_WAS_DUPLICATE: messages.duplicateFileName,
  DATE_RANGE_TOO_LONG: messages.dateSelectionError,
  DATE_RANGE_WRONG_ORDER: messages.endDateAfterStartError,
};
